import { cn } from '@/lib/utils';

interface PlatformBadgeProps {
  platform: 'polymarket' | 'kalshi' | string;
  className?: string;
}

export function PlatformBadge({ platform, className }: PlatformBadgeProps) {
  const normalized = platform.toLowerCase();
  
  const styles = {
    polymarket: 'badge-polymarket',
    kalshi: 'badge-kalshi',
  };

  const labels = {
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium',
        styles[normalized as keyof typeof styles] || 'bg-muted text-muted-foreground',
        className
      )}
    >
      {labels[normalized as keyof typeof labels] || platform}
    </span>
  );
}
